import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
    SharedModule,
    StringCustomFieldConfig,
    FormInputComponent,
    NotificationService
} from '@vendure/admin-ui/core';

import { CustomizationMessageData } from '../common/ui-types';
import { safeJSONParse } from '../../common/ui/utils';

@Component({
    selector: 'vdr-customization-message-form-input',
    template: `
    <vdr-card>
        <div class="form-row">
            <vdr-form-field [label]="'Required'" class="form-item">
                <clr-toggle-wrapper>
                    <input
                        type="checkbox"
                        clrToggle
                        name="required"
                        [formControl]="requiredControl"
                    />
                </clr-toggle-wrapper>
            </vdr-form-field>
        </div>
        <div class="form-row">
            <vdr-form-field [label]="'Label'" class="form-item">
                <input type="text" [formControl]="labelControl">
            </vdr-form-field>
        </div>
        <div class="form-row">
            <vdr-form-field [label]="'Description'" class="form-item">
                <vdr-rich-text-editor [formControl]="descriptionControl" class="form-control">
                </vdr-rich-text-editor>
            </vdr-form-field>
        </div>
    </vdr-card>
    `,
    styleUrls: ['../../common/ui/styles.scss'],
    standalone: true,
    imports: [SharedModule],
})
export class CustomizationMessageFormInputComponent
    implements FormInputComponent<StringCustomFieldConfig>, OnInit, AfterViewInit {
    readonly: boolean;
    config: StringCustomFieldConfig;
    formControl: FormControl;

    labelControl = new FormControl();
    descriptionControl = new FormControl();
    requiredControl = new FormControl();

    customizationMessageData: CustomizationMessageData;

    constructor(
        private notificationService: NotificationService
    ) {}

    ngOnInit() {
        const defaultCustomizationMessageData: CustomizationMessageData = {
            label: '',
            description: '',
            required: false,
        };
        this.customizationMessageData = safeJSONParse<CustomizationMessageData>(
            this.formControl.value,
            this.notificationService,
            defaultCustomizationMessageData
        )!;
        this.initializeFormControls();
    }

    ngAfterViewInit() {
        this.labelControl.valueChanges.subscribe(this.onLabelChange);
        this.descriptionControl.valueChanges.subscribe(this.onDescriptionChange);
        this.requiredControl.valueChanges.subscribe(this.onRequiredChange);
    }

    private initializeFormControls() {
        this.labelControl.setValue(this.customizationMessageData?.label);
        this.descriptionControl.setValue(this.customizationMessageData?.description);
        this.requiredControl.setValue(this.customizationMessageData?.required);
    }

    private onLabelChange = (value: string) => {
        if (this.customizationMessageData?.label !== value) {
            this.customizationMessageData!.label = value;
            this.updateJsonString();
        }
    };

    private onDescriptionChange = (value: string) => {
        if (this.customizationMessageData?.description !== value) {
            this.customizationMessageData!.description = value;
            this.updateJsonString();
        }
    };

    private onRequiredChange = (value: boolean) => {
        if (this.customizationMessageData?.required !== value) {
            this.customizationMessageData!.required = value;
            this.updateJsonString();
        }
    };

    private updateJsonString() {
        this.formControl.setValue(this.customizationMessageData);
        this.formControl.markAsDirty();
    }
}